"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { withSlotScopeClasses } from '../../../../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';
import { Badge } from '../../../../../ui-kit/badge.mjs';
import { Button } from '../../../../../ui-kit/button.mjs';

const panelHeaderRecipe = tv({
  slots: withSlotScopeClasses("panel-header", {
    container: "flex justify-between items-center",
    title: "text-xs leading-[1.125rem] text-slate-11 font-medium m-0",
    actions: "flex gap-2",
    "edit-button": "text-slate-11 font-medium rounded py-0.5 px-1 gap-0.5 h-[initial]"
  })
});
function PanelHeader({ title, actions }) {
  const { container, title: titleStyles, actions: actionsStyles } = panelHeaderRecipe();
  return /* @__PURE__ */ jsxs("div", { className: container(), children: [
    /* @__PURE__ */ jsx("h3", { className: titleStyles(), children: title }),
    /* @__PURE__ */ jsx("div", { className: actionsStyles(), children: actions })
  ] });
}
function PanelHeaderButton({ children, ...props }) {
  const styles = panelHeaderRecipe();
  return /* @__PURE__ */ jsx(Button, { size: "xs", variant: "ghost", colorPalette: "gray", className: styles["edit-button"](), ...props, children });
}
const parametersPreviewRecipe = tv({
  slots: withSlotScopeClasses("parameters-preview", {
    container: "flex gap-2 flex-wrap",
    "no-params": "text-slate-11 text-sm leading-5 font-medium",
    badge: "text-slate-11"
  })
});
function ParametersList({ children }) {
  const styles = parametersPreviewRecipe();
  return /* @__PURE__ */ jsx("div", { className: styles.container(), children });
}
function Parameter({ children }) {
  const styles = parametersPreviewRecipe();
  return /* @__PURE__ */ jsx(Badge, { size: "sm", variant: "subtle", colorPalette: "gray", className: styles.badge(), children });
}
function NoParameters() {
  const styles = parametersPreviewRecipe();
  return /* @__PURE__ */ jsx("span", { className: styles["no-params"](), children: "No parameters provided" });
}
function ParameterText({ title, value }) {
  if (!value) return /* @__PURE__ */ jsx(Fragment, { children: title });
  const truncateTo = 20;
  const truncatedValue = value.length > truncateTo ? `${value?.substring(0, truncateTo)}...` : value;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    title,
    ": ",
    truncatedValue
  ] });
}

export { NoParameters, PanelHeader, PanelHeaderButton, Parameter, ParameterText, ParametersList };
